/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';
import appConfig from '../../runtime/config';
import { logger } from '@/util/logger';
import { checkEnv } from '@/util/browser-env';

const checkEnvObj = checkEnv();

Vue.use(Router);

if (!Router.prototype.__isModify) {
  // 避免重复修改
  Router.prototype.__isModify = true;
  // 替换resolve支持绝对路径(主要是外链)
  Router.prototype.resolve = ((resolve) => function (to, current, append) {
    const next = typeof to === 'string' ? { path: to } : to;
    const result = resolve.call(this, to, current, append);
    // 让route支持完整的URL
    if (/^(?:https?:)?\/\//.test(next.path)) {
      // 去掉seach和hash，route内部会自动从query和hash获取数据拼到path上
      const toPath = next.path.replace(/^([^?#]+)[?#].+$/, '$1');
      // route和resolved被Object.freeze了，需要通过Object.assign来修改值
      result.route = { ...result.route, fullPath: toPath, path: toPath };
      result.resolved = { ...result.resolved, fullPath: toPath, path: toPath };
      result.location.path = toPath;
      result.normalizedTo.path = toPath;
      result.href = next.path;
    }
    return result;
  })(Router.prototype.resolve);
  Vue.options.components['router-link'].options.render = ((render) => function (createElement) {
    const that = this;
    return render.call(this, function (tag, data, slots) {
      const vnode = createElement.call(this, tag, data, slots);
      if (process.env.VUE_ENV === 'server') {
        // 直出版调用指令的stringify钩子
        if (that.$vnode.data.directives && that.$vnode.data.directives.length) {
          that.$vnode.data.directives.forEach((directive) => {
            if (that.$root.$options.directives[directive.name] && typeof that.$root.$options.directives[directive.name].stringify === 'function') {
              that.$root.$options.directives[directive.name].stringify(vnode, directive);
            }
          });
        }
      }
      return vnode;
    });
  })(Vue.options.components['router-link'].options.render);
}

export function createRouter () {
  const router = new Router({
    mode: 'history',
    base: `${appConfig.rootPath}pages/`,
    routes: [
      {
        path: '/community/answer-detail.html',
        name: 'community-answer-detail',
        component: () => System.import('../page/community/answer-detail/index.vue'),
      },
      {
        path: '/community/post-detail.html',
        name: 'community-post-detail',
        component: () => System.import('../page/community/post-detail/index.vue'),
      },
      {
        path: '/community/post-video.html',
        name: 'community-post-video',
        component: () => System.import('../page/community/post-video/index.vue'),
      },
      {
        path: '/community/question-detail.html',
        name: 'community-question-detail',
        component: () => System.import('../page/community/question-detail/index.vue'),
      },
      {
        path: '/preload.html',
        name: 'preload-loading',
        component: () => System.import('../page/common/preload/index_old.vue'),
      },
      {
        path: '/group/tool/career-list.html',
        name: 'group-career-list',
        component: () => System.import('../page/group/tool/career-list/index.vue')
      }
    ],
  });

  if (process.env.VUE_ENV !== 'server') {
    router.beforeEach((to, from, next) => {
      if (checkEnvObj.isApp) {
        next();
      } else if (to.matched.length === 0 || (from.matched.length > 0 && to.matched.length > 0 && from.matched[0].path !== to.matched[0].path)) {
        if (/^(?:https?:)?\/\//.test(to.fullPath)) {
          window.location.href = to.fullPath;
        } else {
          window.location.href = (router.options.base || '').replace(/\/$/, '') + to.fullPath;
        }
        next(false);
      } else {
        next();
      }
      logger.info('vueRouter beforeEach', from.fullPath, to.fullPath);
      next();
    });
    router.afterEach((to, from) => {
      logger.info('vueRouter afterEach', from.fullPath, to.fullPath);
    });
  }

  return router;
}



// WEBPACK FOOTER //
// ../src/router/ssr-router.js